import { inject, injectable } from "inversify";
import { TYPES } from "../di/types";
import { AnalyticsCollector } from "../playerAnalytics/AnalyticsCollector";
import { PlayerManager } from "./PlayerManager";
import { BasePlayerManager } from "./BasePlayerManager";
import { ConfigurationBuilder } from "@manager/configurationBuilder/ConfigurationBuilder";

@injectable()
export class NotSupportedBrowserPlayerManagerImpl extends BasePlayerManager implements PlayerManager {
  constructor(
    @inject(TYPES.analyticsCollector.AnalyticsCollector) analyticsCollector: AnalyticsCollector,
    @inject(TYPES.configurationBuilder.ConfigurationBuilder) configurationBuilder: ConfigurationBuilder,
  ) {
    super(analyticsCollector, configurationBuilder);
  }

  run() {
    this.analyticsCollector.logNotSupportedBrowser();
  }
}
